import React, { useContext } from 'react';
import { Maybe, Price, Product, ProductProperties } from 'src/types';
import { VariantValues } from '../product-variants/types';

type PriceListContextValue = {
  product?: Product & Maybe<{ coreProperties: ProductProperties }>;
  ourChoice?: Price | null;
  variantValues?: VariantValues;
};

export const PriceListContext = React.createContext<PriceListContextValue>({});

export const usePriceListContext = () => useContext(PriceListContext);
